export default __webpack_public_path__ + "static/media/qrcode-ntlt.359b04de.jpg";